export const NavigationRoutes = {
  AUTH_ROUTES: {
    INDEX: "/",
    LOGIN: "/login",
    REGISTER: "/register",
    RESET_PASSWORD: "/reset-password",
    FORGOT_PASSWORD: "/forgot-password",
    OTP_VERIFICATION: "/otp-verification",
  },
  DASHBOARD_ROUTES: {
    DASHBOARD: "/dashboard",
    USER_MANAGEMENT: "/user-management",
    USER_DETAILS: "/user-management/user-details",
    BOOKINGS_MANAGEMENT: "/bookings",
    BOOKING_DETAILS: "/bookings/booking-details",
    WITHDRAWAL_MANAGEMENT: "/withdrawals",
    WITHDRAWAL_DETAILS: "/withdrawals/withdrawal-details",
    DISPUTES_MANAGEMENT: "/disputes",
    DISPUTE_DETAILS: "/disputes/dispute-details",
    REVIEWS_MANAGEMENT: "/reviews",
    VERIFICATION_MANAGEMENT: "/verifications",
    VERIFICATION_DETAIL: "/verifications/verification-detail",
    PROFILE_MANAGEMENT: "/profile-management",
    PROFILE_DETAILS: "/profile-management/profile-details",
    PRODUCT_REQUESTS_MANAGEMENT: "/product-requests",
    PRODUCT_REQUEST_DETAILS: "/product-requests/product-request-details",
  },
};
